import './product-search.scss';

class ProductSearch {
    constructor(element) {
        this.$productSearch = element;
        this.$productSearchToggle = this.$productSearch.querySelector('[data-product-search="toggle"]');
        this.$productSearchForm = this.$productSearch.querySelector('[data-product-search="form"]');
        this.$productSearchField = this.$productSearch.querySelector('[data-product-search-field="input"]');
        this.$productSearchInfo = this.$productSearch.querySelector('[data-product-search="info"]');
        this.$productSearchClearHistoryButton = this.$productSearch.querySelector('[data-product-search="clear"]');
        this.$productSearchFieldHidden = document.querySelector('[data-product-search-field="hidden"]');
        this.$productSearchFieldClear = this.$productSearch.querySelector('[data-product-search-field="clear"]');
        this.$productFilterForm = document.querySelector('[data-product-filter="form"]');
        this.$productSearchTermsValue = this.$productSearch.querySelectorAll('[data-product-search="term-value"]');
        this.$productSearchTermsDelete = this.$productSearch.querySelectorAll('[data-product-search="term-delete"]');
        this.$filterLoader = document.querySelector('[data-product-overview="root"] .loader__item');

        this.icons = {
            clearHistoryBefore: this.$productSearch.dataset.iconClearHistoryBefore || '',
            clearHistory: this.$productSearch.dataset.iconClearHistory || '',
            deleteTerm: this.$productSearch.dataset.iconDeleteTerm || ''
        };

        this.labels = {
            clearHistory: this.$productSearchInfo.dataset.productSearchCleanHistory || '',
            deleteTerm: this.$productSearchInfo.dataset.productSearchCleanRemove || ''
        };
    }

    initialize() {
        if (this.$productSearchFieldHidden) {
            this.$productSearchField.value = this.$productSearchFieldHidden.value;
        } else {
            this.$productSearch.classList.add('product-search--is-hidden');
        }

        this.checkSearchFormVisibility();
        this.checkSearchValue();
        this.setEvents();
    }

    setEvents() {
        if (this.$productSearchToggle) {
            this.$productSearchToggle.addEventListener('click', () => {
                this.$productSearchForm.classList.toggle('product-search__form-content--is-visible');
            });
        }

        if (this.$productSearchField && this.$productSearchFieldHidden) {
            this.$productSearchField.addEventListener('input', (event) => {
                this.$productSearchFieldHidden.value = event.target.value;
            });

            this.$productSearchField.addEventListener('keypress', (event) => {            
                if (event.key === 'Enter') {
                    this.showSpinner();
                    this.handleFormSubmit(true);
                }
            });

            this.$productSearchField.addEventListener('focus', () => {
                this.renderSearchHistory();
            });
        }

        if (this.$productFilterForm) {
            this.$productFilterForm.addEventListener('submit', (event) => {
                this.showSpinner();
          
                //when search trigger
                if (document.activeElement.classList.contains('product-search__button')) {
                    this.handleFormSubmit(true);
                }
                //when checkbox trigger after search
                else {
                    this.handleFormSubmit(false);
                }
            });
        }

        this.$productSearch.addEventListener('click', (event) => {
            event.stopPropagation();
        });

        document.addEventListener('click', (event) => {
            const clickedInsideSearch = this.$productSearch.contains(event.target);

            if (!clickedInsideSearch) {
                this.$productSearchInfo.classList.add('product-search__history--hidden');
            }
        });

        this.$productSearch.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                this.$productSearchInfo.classList.add('product-search__history--hidden');
            }
        });
    }

    getCategoryValue(code) {
        const $categoryLink = document.querySelector(`[data-category-link="${code}"]`);
        if ($categoryLink) {
            const href = $categoryLink.getAttribute('href');
            const url = new URL(href, window.location.origin);
            return url.searchParams.get('productCategories');
        }
        return null;
    }


    
    handleFormSubmit(isSearch = false) {
        const searchValue = this.$productSearchField.value;

        if (isSearch && searchValue) {
            let searchHistory = JSON.parse(localStorage.getItem('product_search_history')) || [];
            if (!searchHistory.includes(searchValue)) {
                searchHistory.unshift(searchValue);
                searchHistory = searchHistory.slice(0, 5);
                localStorage.setItem('product_search_history', JSON.stringify(searchHistory));
                this.renderSearchHistory();
            }
            // Category reset only on search
            const categoryField = document.querySelector('[name="productCategories"]');
            const allCategoryValue = this.getCategoryValue('all-products');
            if (categoryField && allCategoryValue) {
                categoryField.value = allCategoryValue;
            }

            // Reset checkboxes only on search
            const filterInputs = this.$productFilterForm.querySelectorAll('input[type=checkbox]');
            filterInputs.forEach(input => input.checked = false);
        }
       
        this.$productSearchInfo.classList.add('product-search__history--hidden');
        this.$productFilterForm.submit();
    }

    checkSearchFormVisibility() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    if (this.$productSearchForm.classList.contains('product-search__form-content--is-visible')) {
                        this.$productSearchForm.classList.remove('product-search__form-content--is-visible');
                    }
                }
            });
        }, {
            root: null,
            threshold: 0
        });

        observer.observe(this.$productSearchForm);
    }

    renderSearchHistory() {
        const searchHistory = JSON.parse(localStorage.getItem('product_search_history')) || [];
        this.$productSearchInfo.innerHTML = '';

        if (searchHistory.length > 0) {
            const clearLabel = this.$productSearchForm.getAttribute('data-product-search-button-label');
            const clearTerm = document.createElement('div');

            clearTerm.className = 'product-search__term product-search__term--clear-history';

            clearTerm.innerHTML = `
                <div class="product-search__term-value product-search__term-value-history">
                    <span class="product-search__term-value-inner">
                        ${clearLabel}
                    </span>
                </div>
                <button
                    class="product-search__term-delete"
                    data-product-search="clear"
                    aria-label="${this.labels.clearHistory}"
                >
                    ${this.icons.clearHistory}
                </button>`;

            this.$productSearchInfo.appendChild(clearTerm);

            searchHistory.forEach((term, index) => {
                const termElement = document.createElement('div');
                termElement.classList.add('product-search__term');
                termElement.innerHTML = `
                    <span class="product-search__term-icon">
                        ${this.icons.clearHistoryBefore}
                    </span>
                    <div class="product-search__term-value">
                        <span class="product-search__term-value-inner">${term}</span>
                    </div>
                    <button
                        class="product-search__term-delete"
                        data-index="${index}"
                        aria-label="${this.labels.deleteTerm.replace('__TERM__', term)}"
                    >
                        ${this.icons.deleteTerm}
                    </button>`;

                this.$productSearchInfo.appendChild(termElement);

                termElement.querySelector('.product-search__term-value')
                    .addEventListener('click', () => this.selectSearchTerm(term));
            });

            this.$productSearchInfo.classList.remove('product-search__history--hidden');

            this.$productSearchInfo.querySelectorAll('.product-search__term-delete').forEach(button => {
                button.addEventListener('click', (event) => {
                    event.stopPropagation();

                    const deleteButton = event.target.closest('.product-search__term-delete');
                    if (!deleteButton) return;

                    const index = deleteButton.getAttribute('data-index');
                    if (index === null) return;

                    this.deleteSearchTerm(parseInt(index, 10));
                });
            });

            this.$productSearchClearHistoryButton =
                this.$productSearchInfo.querySelector('[data-product-search="clear"]');

            this.$productSearchClearHistoryButton.addEventListener('click', () => {
                this.clearSearchHistory();
            });
        } else {
            this.$productSearchInfo.classList.add('product-search__history--hidden');
        }
    }

    checkSearchValue() {
        if (this.$productSearchFieldHidden && this.$productSearchFieldHidden.value) {
            this.$productSearchFieldClear.classList.remove('product-search__button--hidden');
        }
    }

    deleteSearchTerm(index) {
        const searchHistory = JSON.parse(localStorage.getItem('product_search_history')) || [];
        searchHistory.splice(index, 1);
        localStorage.setItem('product_search_history', JSON.stringify(searchHistory));
        this.renderSearchHistory();
    }

    selectSearchTerm(term) {
        this.$productSearchField.value = term;
        this.$productSearchFieldHidden.value = term;
        this.handleFormSubmit(true);
    }

    clearSearchHistory() {
        localStorage.removeItem('product_search_history');
        this.$productSearchInfo.classList.add('product-search__history--hidden');
        this.$productSearchInfo.innerHTML = '';
    }

    showSpinner() {
        if (this.$filterLoader) this.$filterLoader.hidden = false;

        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                if (this.$filterLoader) this.$filterLoader.hidden = true;
            }
        });
    }
}

export {ProductSearch};

window.addEventListener('content.loaded', (e) => {
    const $context = e.detail.$context;

    if ($context) {
        const $productSearch = $context.querySelectorAll('[data-product-search="root"]');

        for (let i = 0; i < $productSearch.length; i++) {
            const productSearch = new ProductSearch($productSearch[i]);
            productSearch.initialize();
        }
    }
});
